import { currentFilterViewKey } from "./types";

export const setCurrentView = (pageKey: string, viewId: string) => {
    const currentView = localStorage.getItem(currentFilterViewKey) || '{}';
    const parsedCurrentView = JSON.parse(currentView);
    parsedCurrentView[pageKey] = viewId;
    localStorage.setItem(currentFilterViewKey, JSON.stringify(parsedCurrentView));
}